import React from 'react';
import {
  Box,
  LinearProgress,
  Typography,
  Paper,
  CircularProgress,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

const ProgressBar = ({ progress, message, analysisId }) => {
  const getStatusColor = (progress) => {
    if (progress === 100) return 'success';
    if (progress > 70) return 'primary';
    if (progress > 30) return 'info';
    return 'warning';
  };

  return (
    <Paper
      sx={{
        p: 3,
        mb: 3,
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 2 }}>
        {progress === 100 ? (
          <CheckCircleIcon color="success" />
        ) : (
          <CircularProgress size={24} thickness={4} />
        )}
        
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {progress === 100 ? 'Analysis Complete' : 'Processing...'}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {analysisId && `ID: ${analysisId}`}
          </Typography>
        </Box>
        
        <Typography variant="body2" color="primary" sx={{ fontWeight: 600 }}>
          {progress}%
        </Typography>
      </Box>
      
      <LinearProgress
        variant="determinate"
        value={progress}
        color={getStatusColor(progress)}
        sx={{
          height: 8,
          borderRadius: 4,
          mb: 2,
          '& .MuiLinearProgress-bar': {
            borderRadius: 4,
            background: progress === 100
              ? 'linear-gradient(45deg, #4caf50, #66bb6a)'
              : 'linear-gradient(45deg, #00bcd4, #33c9dc)',
          },
        }}
      />
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {progress === 100 ? (
          <CheckCircleIcon fontSize="small" color="success" />
        ) : (
          <HourglassEmptyIcon fontSize="small" color="primary" />
        )}
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </Box>
    </Paper>
  );
};

export default ProgressBar;